import "core-js/modules/es6.object.freeze.js";
import "core-js/modules/es6.string.link.js";
import _isEmpty from "lodash/isEmpty";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment getArticleSchema on Article {\n    __typename\n    id\n    ...getAuthorSchema\n    ...getReviewerSchema\n    ...getEditorSchema\n    ...getAboutSchema\n\n    featuredMediaForJsonLd: featuredMedia {\n      id\n      mediaDetails {\n        id # Required for ApolloClient 3 to cache properly\n        sizes(sizes: [\"primary-m-uncropped\"]) {\n          size\n          sourceUrl\n          width\n          height\n        }\n      }\n    }\n    link\n    modified\n    date\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { gql } from '@nerdwallet/apollo';
import { getCategoryObjects, getCanonicalUrl, getDate, getDateModified, getFeaturedImageInfoWithFallback, getTitleSeo } from '@nerdwallet/wp-api/selectors/common';
import { getAuthorSchema, getReviewerSchema, getEditorSchema, getAboutSchema } from './index';
import { ORGANIZATION } from '../../constants';
/*
 * Get the schema for Article
 *
 * @param  {Object} Article           WordPress Article object
 *
 * @return {Object} Article schema
 */

export var getArticleSchema = function getArticleSchema(article) {
  if (_isEmpty(article)) {
    return null;
  } // eslint-disable-next-line no-use-before-define, no-underscore-dangle


  if (article.__typename) return getArticleSchemaGql(article);
  var authorData = getAuthorSchema(article);
  var reviewerData = getReviewerSchema(article);
  var featuredImageInfo = getFeaturedImageInfoWithFallback(article);
  var imageData = featuredImageInfo && {
    '@type': 'ImageObject',
    url: featuredImageInfo.source_url,
    width: featuredImageInfo.width,
    height: featuredImageInfo.height
  };
  var aboutData = getAboutSchema(getCategoryObjects(article));
  var ArticleClientSchema = {
    '@type': 'Article',
    '@id': "".concat(getCanonicalUrl(article), "#article"),
    // Ensure unique JSON-LD identifier.
    about: aboutData,
    author: authorData,
    dateModified: getDateModified(article),
    datePublished: getDate(article),
    headline: getTitleSeo(article),
    image: imageData,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': getCanonicalUrl(article),
      reviewedBy: reviewerData,
      url: getCanonicalUrl(article)
    },
    publisher: {
      '@id': ORGANIZATION['@id']
    }
  };
  return ArticleClientSchema;
};
getArticleSchema.fragment = gql(_templateObject(), getAuthorSchema.fragment, getReviewerSchema.fragment, getEditorSchema.fragment, getAboutSchema.fragment);
/*
 * Get the schema for Article
 *
 * @param  {Object} Article           query0 Article object
 *
 * @return {Object} Article schema
 */

var getArticleSchemaGql = function getArticleSchemaGql(article) {
  var _article$featuredMedi, _article$featuredMedi2, _article$featuredMedi3;

  if (_isEmpty(article)) {
    return null;
  }

  var authorData = getAuthorSchema(article);
  var reviewerData = getReviewerSchema(article);
  var featuredImageInfo = article === null || article === void 0 ? void 0 : (_article$featuredMedi = article.featuredMediaForJsonLd) === null || _article$featuredMedi === void 0 ? void 0 : (_article$featuredMedi2 = _article$featuredMedi.mediaDetails) === null || _article$featuredMedi2 === void 0 ? void 0 : (_article$featuredMedi3 = _article$featuredMedi2.sizes) === null || _article$featuredMedi3 === void 0 ? void 0 : _article$featuredMedi3[0];
  var imageData = featuredImageInfo && {
    '@type': 'ImageObject',
    url: featuredImageInfo.sourceUrl,
    width: featuredImageInfo.width,
    height: featuredImageInfo.height
  }; // Editor data is only available through GraphQL

  var editorData = getEditorSchema(article);
  var aboutData = getAboutSchema(article);
  var ArticleClientSchema = {
    '@type': 'Article',
    '@id': "".concat(article.link, "#article"),
    // Ensure unique JSON-LD identifier.
    about: aboutData,
    author: authorData,
    editor: editorData,
    dateModified: article === null || article === void 0 ? void 0 : article.modified,
    datePublished: article === null || article === void 0 ? void 0 : article.date,
    headline: article === null || article === void 0 ? void 0 : article.title,
    image: imageData,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': article.link,
      reviewedBy: reviewerData,
      url: article.link
    },
    publisher: {
      '@id': ORGANIZATION['@id']
    }
  };
  return ArticleClientSchema;
};